var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109.2 109.2",
    style: {
      enableBackground: "new 0 0 109.2 109.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000D3D;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.6,
    cy: 54.6,
    r: 54.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.5,52.3c0.5,0.8,0.8,1.7,0.8,2.6c0,1.2-0.5,2.4-1.4,3.3c-0.9,0.9-2.1,1.4-3.3,1.4c-0.9,0-1.8-0.3-2.6-0.8 c-0.8-0.5-1.4-1.2-1.7-2.1c-0.4-0.9-0.4-1.8-0.3-2.7c0.2-0.9,0.6-1.7,1.3-2.4c0.7-0.7,1.5-1.1,2.4-1.3c0.9-0.2,1.8-0.1,2.7,0.3 C81.2,51,82,51.6,82.5,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.5,76c0.5,0.8,0.8,1.7,0.8,2.6c0,1.2-0.5,2.4-1.4,3.3c-0.9,0.9-2.1,1.4-3.3,1.4c-0.9,0-1.8-0.3-2.6-0.8 c-0.8-0.5-1.4-1.2-1.7-2.1c-0.4-0.9-0.4-1.8-0.3-2.7c0.2-0.9,0.6-1.7,1.3-2.4c0.7-0.7,1.5-1.1,2.4-1.3c0.9-0.2,1.8-0.1,2.7,0.3 C81.2,74.6,82,75.2,82.5,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.3,26H72v11.2h11.2V26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.2,76c0.5,0.8,0.8,1.7,0.8,2.6c0,1.2-0.5,2.4-1.4,3.3c-0.9,0.9-2.1,1.4-3.3,1.4c-0.9,0-1.8-0.3-2.6-0.8 c-0.8-0.5-1.4-1.2-1.7-2.1c-0.4-0.9-0.4-1.8-0.3-2.7c0.2-0.9,0.6-1.7,1.3-2.4c0.7-0.7,1.5-1.1,2.4-1.3c0.9-0.2,1.8-0.1,2.7,0.3 C57.9,74.6,58.6,75.2,59.2,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.9,49.3H49.7v11.2h11.2V49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.2,26H49.3v11.8h11.8V26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.5,26H26v12.5h12.5V26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.2,72H26v11.2h11.2V72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.8,49H26v11.8h11.8V49z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetIcon);
export default __webpack_public_path__ + "static/media/fet_icon.fbe2ba9c34e8b2e26ea587f527d99f83.svg";
export { ForwardRef as ReactComponent };